import { render } from "./FrequencyProgram.vue?vue&type=template&id=dd848882"
import script from "./FrequencyProgram.vue?vue&type=script&lang=js"
export * from "./FrequencyProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__